import { cn } from "@aurem/ui";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{ className?: string }>;

export const SidebarIsland = ({ children, className }: Props) => (
  <div
    className={cn(
      "contents sm:flex sm:shrink-0 sm:overflow-hidden",
      "sm:rounded-[1.25rem] sm:bg-accent-500 sm:shadow-md sm:empty:hidden",
      "sm:[&>*+*]:border-s sm:[&>*+*]:border-white/10",
      className,
    )}
  >
    {children}
  </div>
);
